import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import ProductActions from 'actions/ProductActions';
import Actions from 'actions/Actions';
import { createSelector } from 'reselect';
import completePurchaseHistorySelector from 'selectors/completePurchaseHistory/completePurchaseHistorySelector';
import { showPurchasedFlagOnGridPagesSelector } from 'viewModel/selectors/testTarget/showPurchasedFlagOnGridPagesSelector';
import { showStarRatingOnCatalogSelector } from 'viewModel/selectors/testTarget/showStarRatingOnCatalogSelector';
import { showPercentageOffSelector } from 'viewModel/selectors/testTarget/showPercentageOffSelector';
import { showAddBestsellersOnGridPagesSelector } from 'viewModel/selectors/testTarget/showAddBestsellersOnGridPagesSelector';
import { showSkuOptionsPLPSelector } from 'viewModel/selectors/testTarget/showSkuOptionsPLPSelector';
import { showFulfillmentMethodOptimizationPLPSelector } from 'viewModel/selectors/testTarget/showFulfillmentMethodOptimizationPLPSelector';
import { showUpdateQuickLookModalSelector } from 'viewModel/selectors/testTarget/showUpdateQuickLookModalSelector';
import chooseOptionsActions from 'actions/ChooseOptionsActions';

const { wrapHOC } = FrameworkUtils;
const { showSimilarProductsModal } = Actions;

const { fireProductViewableImpressionTracking, fireSponsoredProductClickTracking } = ProductActions;

const fields = createSelector(
    completePurchaseHistorySelector,
    showPurchasedFlagOnGridPagesSelector,
    showStarRatingOnCatalogSelector,
    showPercentageOffSelector,
    showAddBestsellersOnGridPagesSelector,
    showSkuOptionsPLPSelector,
    showFulfillmentMethodOptimizationPLPSelector,
    showUpdateQuickLookModalSelector,
    (
        completePurchaseHistory,
        showPurchasedFlagOnGridPages,
        showStarRatingOnCatalog,
        showPercentageOff,
        showAddBestsellersOnGridPages,
        showSkuOptionsPLP,
        showFulfillmentMethodOptimizationPLP,
        showUpdateQuickLookModal
    ) => {
        return {
            completePurchaseHistory,
            showPurchasedFlagOnGridPages,
            showStarRatingOnCatalog,
            showPercentageOff,
            showAddBestsellersOnGridPages,
            showSkuOptionsPLP,
            showFulfillmentMethodOptimizationPLP,
            showUpdateQuickLookModal
        };
    }
);

const functions = {
    fireProductViewableImpressionTracking,
    fireSponsoredProductClickTracking,
    showSimilarProductsModal,
    showChooseOptionsModal: chooseOptionsActions.showChooseOptionsModal
};

const withProductTileProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withProductTileProps
};
